import { render, staticRenderFns } from "./GenInfoForm.vue?vue&type=template&id=1acf745f"
import script from "./GenInfoForm.vue?vue&type=script&lang=js"
export * from "./GenInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports